import React from 'react';
import { Field, ErrorMessage, useField } from 'formik';
import './index.scss';

interface IProps {
  name: string;
  id?: string;
  label: string;
  placeholder?: string;
  inputWrapperClass?: string;
  inputClass?: string;
  required?: boolean;
}

export const TextAreaPro = ({
  name,
  id,
  label,
  placeholder,
  inputWrapperClass,
  inputClass,
  required
}: IProps) => {
  const [, meta] = useField(name);

  return (
    <div className={`input-wrapper ${inputWrapperClass}`}>
      <label htmlFor={id || name} className="input-label">
        {label}
        {required ? <span className="input-required">*</span> : null}
      </label>
      <Field
        as="textarea"
        className={`input-textarea-box ${inputClass} ${
          meta.touched && meta.error ? 'input-error' : ''
        }`}
        name={name}
        id={id || name}
        placeholder={placeholder}
      />
      <ErrorMessage name={name} component="div" className="error" />
    </div>
  );
};

interface IPropsControlled extends IProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const TextAreaProControlled = ({
  name,
  id,
  label,
  placeholder,
  inputWrapperClass,
  inputClass,
  required,
  disabled,
  value,
  onChange
}: IPropsControlled) => {
  return (
    <div className={`input-wrapper ${inputWrapperClass}`}>
      {label && (
        <label htmlFor={id || name} className="input-label">
          {label}
          {required ? <span className="input-required">*</span> : null}
        </label>
      )}
      <textarea
        className={`input-textarea-box ${inputClass}`}
        name={name}
        id={id || name}
        placeholder={placeholder}
        disabled={disabled}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};
